import { normalizeFacetValueIds, parseDataAttributes } from '../../utilities/utilities'
import type { TypographyConfig, ButtonConfig } from '../../types/widget-types'

export type ProductListConfigStyles = {
  addToCartButtonVariant: ButtonConfig
  paginationButtonVariant: ButtonConfig
  productInStockTypography: TypographyConfig
  productNameTypography: TypographyConfig
  productPriceTypography: TypographyConfig
  listPriceTypography: TypographyConfig
}

export type ProductListAttributes = {
  productListIdentifier?: string
  facetValueIds?: string[]
  collectionId?: string
  enablePagination: boolean
  take: number
  buttonVariant?: string
  showCta?: boolean
  showInStock?: boolean
  showPrice?: boolean
  showBadges?: boolean
  configStyles?: ProductListConfigStyles
}

export function getProductListAttributes(attrs: NamedNodeMap): ProductListAttributes {
  const base = parseDataAttributes(attrs) as Record<string, unknown>

  const productListIdentifier = base.productListIdentifier as string | undefined

  const facetValueIds = normalizeFacetValueIds(base.facetValueIds)

  const collectionId = (base.collection as string | undefined) ?? undefined

  const enablePagination = Boolean(base.paginationEnabled)
  const take = base.take as number | undefined

  const buttonVariant = base.buttonVariant as string | undefined

  const showCta = base.showCta === 'yes' || base.showCta === true
  const showInStock = base.showInStock === 'yes' || base.showInStock === true
  const showPrice = base.showPrice === 'yes' || base.showPrice === true
  const showBadges = base.showBadges === 'yes' || base.showBadges === true
  return {
    productListIdentifier,
    facetValueIds,
    collectionId,
    enablePagination,
    take: take ?? 12,
    buttonVariant,
    showCta,
    showInStock,
    showPrice,
    showBadges,
    configStyles: base.configStyles as ProductListConfigStyles | undefined,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): ProductListAttributes {
  return getProductListAttributes(dataAttributes)
}
